<template>
  <div>
    <sSelect
      class="width-100"
      clearable
      multiple
      :placeholder="$t('Common.Select')"
      :value.sync="valueMutable">
      <sOption
        v-for="valueName in valueNames"
        :key="valueName"
        :label="$t(`Automation.${valueName}`)"
        :value="valueName"/>
    </sSelect>
    <div v-if="valueMutable && valueMutable.length > 1">
      <sChip
        v-for="valueItem in valueMutable"
        :key="valueItem"
        background="var(--color-success)"
        class="mr-2"
        :text="$t(`Automation.${valueItem}`)"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SendTo',
  data() {
    return {
      valueNames: ['SendToResposible', 'SendToTenderParticipants', 'SendToInvitedParticipants', 'SendToApprovers'],
    }
  },
  computed: {
    valueMutable: {
      get() {
        return Object.entries(this.value)
          .filter(i => this.valueNames.includes(i[0]))
          .filter( i => i[1]).map(i => i[0])
      },
      set(value) {
        const result = {... this.value}
        this.valueNames.forEach(element => {
          result[element] = value.includes(element)
        })
        this.$emit('update:value', result)
      },
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
}
</script>
